import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const validatorCarrier = v.object({
  name: v.string(),
  code: v.string(),
  isActive: v.boolean(),
  internalControl: internalControl,
});

export const carriers = defineTable(validatorCarrier)
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_state", ["internalControl.state"])
  .index("by_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_branch_and_state", [
    "internalControl.branchId",
    "internalControl.state",
  ])
  .index("by_created_by", ["internalControl.createdBy"])
  .index("by_updated_by", ["internalControl.updatedBy"])
  .index("by_created_at", ["internalControl.createdAt"])
  .index("by_company_and_created_at", [
    "internalControl.companyId",
    "internalControl.createdAt",
  ])
  .index("by_code", ["code"])
  .index("by_is_active", ["isActive"])
  .index("by_company_and_code", ["internalControl.companyId", "code"])
  .index("by_company_and_active", ["internalControl.companyId", "isActive"])
  .searchIndex("search_carriers", {
    searchField: "name",
    filterFields: [
      "internalControl.companyId",
      "internalControl.state",
      "isActive",
    ],
  });
